import { Icon, Menu, MenuGroup, MenuItem, MenuOptions } from '@bechtel/gds';
import { FC, useEffect, useRef } from 'react';
import { IconButtonStyled, MultiLingualText, useLanguage } from '~/components';
import { useOutsideClick } from '~/hooks';

const CommodityMenuOptions: FC<{ toggle }> = ({ toggle }) => {
  const sampleOptions = [{ title: 'Help', options: ['Docs', 'FAQ'] }];
  const ref = useRef();
  const { getMultiLingualTextByKey } = useLanguage();
  useOutsideClick(ref, () => {
    toggle();
  });

  useEffect(() => {
    const closeOnEscapePressed = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        toggle();
      }
    };
    window.addEventListener('keydown', closeOnEscapePressed);
    return () => window.removeEventListener('keydown', closeOnEscapePressed);
  }, [toggle]);

  return (
    <MenuOptions ref={ref}>
      {sampleOptions.map(({ title, options }) => {
        const displayTitle = getMultiLingualTextByKey(title);
        return (
          <MenuGroup key={displayTitle} title={displayTitle}>
            {options.map((option) => (
              <MenuItem key={option}>
                <MultiLingualText>{option}</MultiLingualText>
              </MenuItem>
            ))}
          </MenuGroup>
        );
      })}
    </MenuOptions>
  );
};

const CommodityMenu = () => {
  return (
    <Menu>
      {({ placement, isOpen, toggle, referenceRef, popperRef }) => (
        <>
          <div ref={referenceRef}>
            <IconButtonStyled>
              <Icon icon="ellipsis-v" iconStyle="regular" onClick={toggle} fillColor="primary.900" />
            </IconButtonStyled>
          </div>
          <div ref={popperRef} data-placement={placement} style={{ zIndex: 1 }}>
            {isOpen && <CommodityMenuOptions toggle={toggle} />}
          </div>
        </>
      )}
    </Menu>
  );
};

export default CommodityMenu;
